import { GlobalStatus } from "@gtpl/shared-models/common-models";

export class DomesticSalesReqDto {
    // domesticSaleOrderNo?:string;
    varientId?: number;
    stockId ?: number;
    locationId?:number;

    constructor(
        // domesticSaleOrderNo?:string,
        varientId?: number,
        stockId?: number,
        locationId?:number,

    ) {
        this.varientId = varientId;
        this.stockId = stockId;
        this.locationId = locationId;
        // this.domesticSaleOrderNo = domesticSaleOrderNo;
    }
}